export const pppLoanPaymentDeferralSelector = ({ config, entities }) => ({
  advances: entities.advances,
  loanbuilderUrl: config.loanbuilderUrl,
  loanForgiveness: entities.loanForgiveness,
});
